// Module
var code = "<div class=\"markdown-renderer\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"> </wt-loading-panel> <div ng-bind-html=\"vm.rendered\"></div> </div>";
// Exports
module.exports = code;